import React, { Component } from 'react'

export class GreenButton extends Component {
    render() {
        return (
            <button style={this.props.style} onClick={this.props.continue} className="greenButton">
                {this.props.name}
            </button>
        )
    }
}

export default GreenButton
